module.exports = __webpack_public_path__ + "img/case-logo-21.1b68f884.png";